// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddLead_lead_ref_tabpanel__h3V4p {
  width: 600px;
}
.AddLead_lead_ref_heading__gJUAs {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}

.AddLead_lead_ref_form__bU7MM {
  /* max-width: 500px; */
  /* width: 100%; */
  width: 100%;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.AddLead_lead_ref_form__bU7MM label {
  font-size: 16px;
  font-weight: 500;
  color: #555;
  display: block;
  margin-bottom: 5px;
}

.AddLead_lead_ref_input__QM9vk,
.AddLead_lead_ref_select__GJ5bq {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  display: block;
}

.AddLead_lead_ref_select__GJ5bq {
  background: #fff;
  appearance: none;
}

.AddLead_nextButton__MfsNV {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  display: block;
  transition: background 0.3s ease-in-out;
}

.AddLead_nextButton__MfsNV:hover {
  background: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .AddLead_lead_ref_tabpanel__h3V4p {
    width: 515px;
  }
  .AddLead_lead_ref_form__bU7MM {
    padding: 15px;
  }

  .AddLead_lead_ref_input__QM9vk,
  .AddLead_lead_ref_select__GJ5bq,
  .AddLead_nextButton__MfsNV {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .AddLead_lead_ref_tabpanel__h3V4p {
    width: 315px;
  }
  .AddLead_lead_ref_heading__gJUAs {
    font-size: 20px;
  }

  .AddLead_lead_ref_form__bU7MM {
    padding: 10px;
  }

  .AddLead_lead_ref_input__QM9vk,
  .AddLead_lead_ref_select__GJ5bq,
  .AddLead_nextButton__MfsNV {
    font-size: 14px;
    padding: 10px;
  }
}

.AddLead_company_detail_tabpannel__ica3Q {
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  /* padding: 20px; */
  border-radius: 10px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}

.AddLead_tabHeading__aQg2u {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}

.AddLead_company_detail_tabpannel__ica3Q input {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  display: block;
}

.AddLead_company_detail_tabpannel__ica3Q input::placeholder {
  color: #aaa;
}

.AddLead_nextButton__MfsNV {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  display: block;
  transition: background 0.3s ease-in-out;
}

.AddLead_nextButton__MfsNV:hover {
  background: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .AddLead_company_detail_tabpannel__ica3Q {
    padding: 15px;
  }

  .AddLead_company_detail_tabpannel__ica3Q input,
  .AddLead_nextButton__MfsNV {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .AddLead_tabHeading__aQg2u {
    font-size: 20px;
  }

  .AddLead_company_detail_tabpannel__ica3Q {
    padding: 10px;
  }

  .AddLead_company_detail_tabpannel__ica3Q input,
  .AddLead_nextButton__MfsNV {
    font-size: 14px;
    padding: 10px;
  }
}
/* employee design */
.AddLead_employe_detail_tabpannel__\\+SmfO {
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  /* padding: 20px; */
  border-radius: 10px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}

.AddLead_employe_detail_tabHeading__GkakM {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}

.AddLead_employe_detail_tabpannel__\\+SmfO input {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  display: block;
}

.AddLead_employe_detail_tabpannel__\\+SmfO input::placeholder {
  color: #aaa;
}

.AddLead_nextButton__MfsNV {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  display: block;
  transition: background 0.3s ease-in-out;
}

.AddLead_nextButton__MfsNV:hover {
  background: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .AddLead_employe_detail_tabpannel__\\+SmfO {
    padding: 15px;
  }

  .AddLead_employe_detail_tabpannel__\\+SmfO input,
  .AddLead_nextButton__MfsNV {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .AddLead_employe_detail_tabHeading__GkakM {
    font-size: 20px;
  }

  .AddLead_employe_detail_tabpannel__\\+SmfO {
    padding: 10px;
  }

  .AddLead_employe_detail_tabpannel__\\+SmfO input,
  .AddLead_nextButton__MfsNV {
    font-size: 14px;
    padding: 10px;
  }
}
/* need */

.AddLead_need_tabpannel__sq8H4 {
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  /* padding: 20px; */
  border-radius: 10px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}

.AddLead_need_tabHeading__xGDNc {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}

.AddLead_source__JmPmw {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}

.AddLead_source__JmPmw input {
  width: 48%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.AddLead_need_tabpannel__sq8H4 label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
  font-size: 14px;
  color: #555;
}

.AddLead_need_tabpannel__sq8H4 input {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  display: block;
}

.AddLead_need_tabpannel__sq8H4 input::placeholder {
  color: #aaa;
}

.AddLead_additionalField__Pe4Ow {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.AddLead_additionalField__Pe4Ow input {
  flex: 1 1;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.AddLead_need_tabpannel__sq8H4 button {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  display: block;
  transition: background 0.3s ease-in-out;
  margin-top: 10px;
}
.AddLead_need_tabpannel__sq8H4 select {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  display: block;
}
.AddLead_need_tabpannel__sq8H4 button:hover {
  background: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .AddLead_need_tabpannel__sq8H4 {
    padding: 15px;
  }

  .AddLead_need_tabpannel__sq8H4 input,
  .AddLead_source__JmPmw input,
  .AddLead_need_tabpannel__sq8H4 button {
    max-width: 100%;
  }

  .AddLead_source__JmPmw {
    flex-direction: column;
    gap: 5px;
  }

  .AddLead_source__JmPmw input {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .AddLead_need_tabHeading__xGDNc {
    font-size: 20px;
  }

  .AddLead_need_tabpannel__sq8H4 {
    padding: 10px;
  }

  .AddLead_need_tabpannel__sq8H4 input,
  .AddLead_need_tabpannel__sq8H4 button {
    font-size: 14px;
    padding: 10px;
  }
}
/* note design */
.AddLead_note_tabpanel__Gc\\+ni {
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  /* padding: 20px; */
  border-radius: 10px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}

.AddLead_note_tabHeading__YT-g7 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}

.AddLead_note_tabpanel__Gc\\+ni input,
.AddLead_note_tabpanel__Gc\\+ni select {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  display: block;
}

.AddLead_note_tabpanel__Gc\\+ni input::placeholder {
  color: #aaa;
}

.AddLead_note_tabpanel__Gc\\+ni select {
  background: #fff;
}

.AddLead_rating__kWxwr {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 15px 0;
  justify-content: flex-start;
}

.AddLead_rating__kWxwr span {
  font-size: 32px; /* Increased size */
  cursor: pointer;
  color: #f5a623;
  transition: color 0.3s ease-in-out;
}

.AddLead_starActive__JG-gs {
  color: #f5a623;
}

.AddLead_submitButton__qEvQm {
  width: 100%;
  max-width: 450px;
  padding: 12px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  display: block;
  transition: background 0.3s ease-in-out;
  margin-top: 10px;
}

.AddLead_submitButton__qEvQm:hover {
  background: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .AddLead_note_tabpanel__Gc\\+ni {
    padding: 15px;
  }

  .AddLead_note_tabpanel__Gc\\+ni input,
  .AddLead_note_tabpanel__Gc\\+ni select,
  .AddLead_submitButton__qEvQm {
    max-width: 100%;
  }

  .AddLead_rating__kWxwr {
    justify-content: flex-start; /* Ensure stars stay left */
  }

  .AddLead_rating__kWxwr span {
    font-size: 28px; /* Slightly smaller on mobile */
  }
}

@media (max-width: 480px) {
  .AddLead_note_tabHeading__YT-g7 {
    font-size: 20px;
  }

  .AddLead_note_tabpanel__Gc\\+ni {
    padding: 10px;
  }

  .AddLead_note_tabpanel__Gc\\+ni input,
  .AddLead_note_tabpanel__Gc\\+ni select,
  .AddLead_submitButton__qEvQm {
    font-size: 14px;
    padding: 10px;
  }

  .AddLead_rating__kWxwr span {
    font-size: 24px; /* Adjusted for mobile */
  }
}

.AddLead_end_user_tabpannel__q8VLB {
  background: #fff;
  /* padding: 20px; */
  border-radius: 10px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  max-width: 400px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.AddLead_end_user_tabHeading__xjvki {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 15px;
}

.AddLead_end_user_input_field__d61S2 {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  transition: all 0.3s ease;
  width: 100%;
}

.AddLead_end_user_input_field__d61S2:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/styles/AddLead.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,aAAa;EACf;AACF;AACA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,aAAa;EACf;AACF;AACA,SAAS;;AAET;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,aAAa;EACf;AACF;AACA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,eAAe,EAAE,mBAAmB;EACpC,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,2BAA2B,EAAE,2BAA2B;EAC1D;;EAEA;IACE,eAAe,EAAE,+BAA+B;EAClD;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe,EAAE,wBAAwB;EAC3C;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,0CAA0C;AAC5C","sourcesContent":[".lead_ref_tabpanel {\n  width: 600px;\n}\n.lead_ref_heading {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.lead_ref_form {\n  /* max-width: 500px; */\n  /* width: 100%; */\n  width: 100%;\n  margin: 0 auto;\n  background: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.lead_ref_form label {\n  font-size: 16px;\n  font-weight: 500;\n  color: #555;\n  display: block;\n  margin-bottom: 5px;\n}\n\n.lead_ref_input,\n.lead_ref_select {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  display: block;\n}\n\n.lead_ref_select {\n  background: #fff;\n  appearance: none;\n}\n\n.nextButton {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  background: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  font-size: 18px;\n  cursor: pointer;\n  text-align: center;\n  display: block;\n  transition: background 0.3s ease-in-out;\n}\n\n.nextButton:hover {\n  background: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .lead_ref_tabpanel {\n    width: 515px;\n  }\n  .lead_ref_form {\n    padding: 15px;\n  }\n\n  .lead_ref_input,\n  .lead_ref_select,\n  .nextButton {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .lead_ref_tabpanel {\n    width: 315px;\n  }\n  .lead_ref_heading {\n    font-size: 20px;\n  }\n\n  .lead_ref_form {\n    padding: 10px;\n  }\n\n  .lead_ref_input,\n  .lead_ref_select,\n  .nextButton {\n    font-size: 14px;\n    padding: 10px;\n  }\n}\n\n.company_detail_tabpannel {\n  max-width: 500px;\n  width: 100%;\n  margin: 0 auto;\n  background: #fff;\n  /* padding: 20px; */\n  border-radius: 10px;\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\n}\n\n.tabHeading {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.company_detail_tabpannel input {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  display: block;\n}\n\n.company_detail_tabpannel input::placeholder {\n  color: #aaa;\n}\n\n.nextButton {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  background: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  font-size: 18px;\n  cursor: pointer;\n  text-align: center;\n  display: block;\n  transition: background 0.3s ease-in-out;\n}\n\n.nextButton:hover {\n  background: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .company_detail_tabpannel {\n    padding: 15px;\n  }\n\n  .company_detail_tabpannel input,\n  .nextButton {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .tabHeading {\n    font-size: 20px;\n  }\n\n  .company_detail_tabpannel {\n    padding: 10px;\n  }\n\n  .company_detail_tabpannel input,\n  .nextButton {\n    font-size: 14px;\n    padding: 10px;\n  }\n}\n/* employee design */\n.employe_detail_tabpannel {\n  max-width: 500px;\n  width: 100%;\n  margin: 0 auto;\n  background: #fff;\n  /* padding: 20px; */\n  border-radius: 10px;\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\n}\n\n.employe_detail_tabHeading {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.employe_detail_tabpannel input {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  display: block;\n}\n\n.employe_detail_tabpannel input::placeholder {\n  color: #aaa;\n}\n\n.nextButton {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  background: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  font-size: 18px;\n  cursor: pointer;\n  text-align: center;\n  display: block;\n  transition: background 0.3s ease-in-out;\n}\n\n.nextButton:hover {\n  background: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .employe_detail_tabpannel {\n    padding: 15px;\n  }\n\n  .employe_detail_tabpannel input,\n  .nextButton {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .employe_detail_tabHeading {\n    font-size: 20px;\n  }\n\n  .employe_detail_tabpannel {\n    padding: 10px;\n  }\n\n  .employe_detail_tabpannel input,\n  .nextButton {\n    font-size: 14px;\n    padding: 10px;\n  }\n}\n/* need */\n\n.need_tabpannel {\n  max-width: 500px;\n  width: 100%;\n  margin: 0 auto;\n  background: #fff;\n  /* padding: 20px; */\n  border-radius: 10px;\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\n}\n\n.need_tabHeading {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.source {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n}\n\n.source input {\n  width: 48%;\n  padding: 12px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.need_tabpannel label {\n  display: block;\n  margin-top: 10px;\n  font-weight: bold;\n  font-size: 14px;\n  color: #555;\n}\n\n.need_tabpannel input {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  display: block;\n}\n\n.need_tabpannel input::placeholder {\n  color: #aaa;\n}\n\n.additionalField {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.additionalField input {\n  flex: 1;\n  padding: 12px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.need_tabpannel button {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  background: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  font-size: 18px;\n  cursor: pointer;\n  text-align: center;\n  display: block;\n  transition: background 0.3s ease-in-out;\n  margin-top: 10px;\n}\n.need_tabpannel select {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  display: block;\n}\n.need_tabpannel button:hover {\n  background: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .need_tabpannel {\n    padding: 15px;\n  }\n\n  .need_tabpannel input,\n  .source input,\n  .need_tabpannel button {\n    max-width: 100%;\n  }\n\n  .source {\n    flex-direction: column;\n    gap: 5px;\n  }\n\n  .source input {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .need_tabHeading {\n    font-size: 20px;\n  }\n\n  .need_tabpannel {\n    padding: 10px;\n  }\n\n  .need_tabpannel input,\n  .need_tabpannel button {\n    font-size: 14px;\n    padding: 10px;\n  }\n}\n/* note design */\n.note_tabpanel {\n  max-width: 500px;\n  width: 100%;\n  margin: 0 auto;\n  background: #fff;\n  /* padding: 20px; */\n  border-radius: 10px;\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\n}\n\n.note_tabHeading {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.note_tabpanel input,\n.note_tabpanel select {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  display: block;\n}\n\n.note_tabpanel input::placeholder {\n  color: #aaa;\n}\n\n.note_tabpanel select {\n  background: #fff;\n}\n\n.rating {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 15px 0;\n  justify-content: flex-start;\n}\n\n.rating span {\n  font-size: 32px; /* Increased size */\n  cursor: pointer;\n  color: #f5a623;\n  transition: color 0.3s ease-in-out;\n}\n\n.starActive {\n  color: #f5a623;\n}\n\n.submitButton {\n  width: 100%;\n  max-width: 450px;\n  padding: 12px;\n  background: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  font-size: 18px;\n  cursor: pointer;\n  text-align: center;\n  display: block;\n  transition: background 0.3s ease-in-out;\n  margin-top: 10px;\n}\n\n.submitButton:hover {\n  background: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .note_tabpanel {\n    padding: 15px;\n  }\n\n  .note_tabpanel input,\n  .note_tabpanel select,\n  .submitButton {\n    max-width: 100%;\n  }\n\n  .rating {\n    justify-content: flex-start; /* Ensure stars stay left */\n  }\n\n  .rating span {\n    font-size: 28px; /* Slightly smaller on mobile */\n  }\n}\n\n@media (max-width: 480px) {\n  .note_tabHeading {\n    font-size: 20px;\n  }\n\n  .note_tabpanel {\n    padding: 10px;\n  }\n\n  .note_tabpanel input,\n  .note_tabpanel select,\n  .submitButton {\n    font-size: 14px;\n    padding: 10px;\n  }\n\n  .rating span {\n    font-size: 24px; /* Adjusted for mobile */\n  }\n}\n\n.end_user_tabpannel {\n  background: #fff;\n  /* padding: 20px; */\n  border-radius: 10px;\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */\n  max-width: 400px;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.end_user_tabHeading {\n  font-size: 20px;\n  font-weight: bold;\n  color: #333;\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n.end_user_input_field {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  transition: all 0.3s ease;\n  width: 100%;\n}\n\n.end_user_input_field:focus {\n  border-color: #007bff;\n  outline: none;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lead_ref_tabpanel": `AddLead_lead_ref_tabpanel__h3V4p`,
	"lead_ref_heading": `AddLead_lead_ref_heading__gJUAs`,
	"lead_ref_form": `AddLead_lead_ref_form__bU7MM`,
	"lead_ref_input": `AddLead_lead_ref_input__QM9vk`,
	"lead_ref_select": `AddLead_lead_ref_select__GJ5bq`,
	"nextButton": `AddLead_nextButton__MfsNV`,
	"company_detail_tabpannel": `AddLead_company_detail_tabpannel__ica3Q`,
	"tabHeading": `AddLead_tabHeading__aQg2u`,
	"employe_detail_tabpannel": `AddLead_employe_detail_tabpannel__+SmfO`,
	"employe_detail_tabHeading": `AddLead_employe_detail_tabHeading__GkakM`,
	"need_tabpannel": `AddLead_need_tabpannel__sq8H4`,
	"need_tabHeading": `AddLead_need_tabHeading__xGDNc`,
	"source": `AddLead_source__JmPmw`,
	"additionalField": `AddLead_additionalField__Pe4Ow`,
	"note_tabpanel": `AddLead_note_tabpanel__Gc+ni`,
	"note_tabHeading": `AddLead_note_tabHeading__YT-g7`,
	"rating": `AddLead_rating__kWxwr`,
	"starActive": `AddLead_starActive__JG-gs`,
	"submitButton": `AddLead_submitButton__qEvQm`,
	"end_user_tabpannel": `AddLead_end_user_tabpannel__q8VLB`,
	"end_user_tabHeading": `AddLead_end_user_tabHeading__xjvki`,
	"end_user_input_field": `AddLead_end_user_input_field__d61S2`
};
export default ___CSS_LOADER_EXPORT___;
